// extracted by mini-css-extract-plugin
export default {"container":"kWhPqa","row":"sQljHI","container-dark-bg-color":"kOWL3C","containerDarkBgColor":"kOWL3C"};